import styled from "styled-components";

export const Container = styled.div`
  min-width: 115px;
`;

export const Step = styled.span`
  width: 16px;
  height: 16px;
  background: white;
  display: inline-block;
  margin-right: 5px;
  border-radius: 50%;
  border: ${({ theme }) => `1px solid ${theme.palette.primary.main}`};

  ${({ active, theme }) =>
    active &&
    `
    border:none;
    background:${theme.palette.primary.main};
    `}
`;
